import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    animationSelector: '[class*="page-transition-"]',
    plugins: [new SwupPreloadPlugin()]
});

init();

function init() {
}

let pageChangingEvent = new Event("pageChanging");
let pageChangedEvent = new Event("pageChanged");

swup.on('pageLoaded', function () {
  init();
  window.dispatchEvent(new Event('resize'));
});

swup.on('animationOutStart', function () {
    console.log('changing');
    document.dispatchEvent(pageChangingEvent);
});

swup.on('contentReplaced', function () {
    console.log('done');
    window.scrollTo(0, 0);
    document.dispatchEvent(pageChangingEvent);
    init();
});
